import React from "react";

const Chat = () => {
  return (
    <div>
      <h1>Chat Page</h1>
    </div>
  );
};

export default Chat;
